import EventBus from "common/eventbus";
import Events from "common/events";
import { initApp } from "components/jiffy/jiffy-services-preview/jiffy-services-preview";
import initMadeSampleCTA from "components/jiffy/product-details-made-sample-cta/product-details-made-sample-cta";

import "./product-details-header.scss";

const $getSoftnessScoreAll = () => document.querySelectorAll(".js-header-softness-score");
const $getSoftnessScore = $badge => $badge.querySelector(".js-softness-score-number");
const $getSoftnessRating = $badge => $badge.querySelector(".js-softness-score-rating");
const $getCreditBalance = () => document.querySelectorAll(".js-credit-balance");

const updateSoftnessScore = (_, { softness }) => {
  const isHiddenBadges = !Object.keys(softness).length;

  $getSoftnessScoreAll().forEach($badge => {
    $badge.classList.toggle("hidden", isHiddenBadges);

    if (!isHiddenBadges) {
      $getSoftnessScore($badge).textContent = softness.score;
      $getSoftnessRating($badge).style.width = `${softness.percentage}%`;
    }
  });
};

const updateCreditsAvailable = ({ target }) => {
  const totalAmount = target?.userStoreCredits?.transfers?.totalAmount;
  const formattedTotalAmount = Number(totalAmount || 0).toFixed(2);

  const $creditBalances = $getCreditBalance();
  if (!$creditBalances || $creditBalances.length === 0) return;

  $creditBalances.forEach($balance => {
    if (!$balance) return;

    const $amount = $balance.querySelector(".js-credit-balance-amount");
    if ($amount) {
      $amount.textContent = `$${formattedTotalAmount}`;
    }
  });
};

export default () => {
  initApp(".js-upsell-container");
  initMadeSampleCTA();

  EventBus.on(Events.PRODUCT_COLOR_SELECTED, updateSoftnessScore);
  EventBus.on(Events.PRICING_UPDATED, updateCreditsAvailable);
};
